export default __webpack_public_path__ + "static/pro@992_2x-b237a3b531c121176e4c4009edd7f221.jpg";